export {
  DeckCardSectionDetailsTilesView,
  type DeckCardTile,
} from "#deck-card-section-details-tiles-view";
